import axios from "../../../../axios";
import React, { useEffect, useState, useRef } from "react";
import CreateChannelFirst from "../../Create_channel/Create_channel_screen/CreateChannelFirst";
// import ChannelBoxProps from "../../Create_channel/Empty_Screen/Channels_List/ChannelBoxProps";
import ChannelBox from "../../Create_channel/Empty_Screen/Channels_List/ChannelBox";
import CreatePostFirst from "../Create_Post_screen/CreatePostFirst";
import PostImage from "./recent_post Img/PostImage";
import Form from "react-bootstrap/Form";
import "./totalCommuPost.css";
import FilterBox from "./Filter_Box/FilterBox";
import Popup from "reactjs-popup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ImagePopupBox from "../../../../DCM/components/PopUp/ImagePopup/ImagePopupBox";
import CommuityImage from "../../../../images/Community_Process_Flow.png";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { Alert } from "@mui/material";

const TotalCommuPost = () => {
  const popupRef = useRef(null);
  const [openImg, setOpenImg] = useState(false);
  const [clickCreate, setClickCreate] = useState(false);
  const [clickPost, setClickPost] = useState(false);
  const [topicPopupOpen, setTopicPopupOpen] = useState(false);
  const [topicList, setTopicList] = useState([]);
  const [click1, setClick1] = useState(false);
  const [option, setOption] = useState("");
  const [isPostCreated, setIsPostCreated] = useState(false);
  const [postRequestCount, setPostRequestCount] = useState(0);
  const [inProgress, setInProgress] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [isEdited, setIsEdited] = useState(false);
  const loadingRef = useRef(false);
  const lastPageRef = useRef(false);
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [checked, setChecked] = useState({
    sortChecked: 2,
    timeChecked: 1,
  });
  const [community, setCommunity] = useState([]);
  const [allPost, setAllPost] = useState([]);
  const [filter, setFilter] = useState({
    date: null,
    tag: null,
    name: null,
    sortBy: -1,
    time: null,
    limit: 20,
    page: 1,
    searchClick: false,
    topicSearchInput: "",
  });
  const {
    date,
    tag,
    name,
    limit,
    page,
    sortBy,
    time,
    searchClick,
    topicSearchInput,
  } = filter;

  const [viewFirstInProgress, setViewFirstInProgress] = useState(false);
  const [postCreatedCount, setPostCreatedCount] = useState(0);
  const [selectedCommunity, setSelectedCommunity] = useState();
  const [active, setActive] = useState("About");
  const location = useLocation();
  useEffect(() => {
    const getCommunity = async () => {
      try {
        const resp = await axios.get(
          `/api/v1/community/getByUserId/teacher/${teacher_id}`,
        );
        resp && setCommunity(resp.data.data);
      } catch (error) {
        console.log(error);
      }
    };
    getCommunity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  console.log(community, "comunithy kya hai");
  useEffect(() => {
    const getPostTopic = async () => {
      let filterData;
      try {
        let res = await axios.get(
          `/api/v1/community/post/topic/getByUserId/teacher/${teacher_id}`,
        );
        if (res) {
          filterData = res.data.data.filter((topic) =>
            topic.topic.toLowerCase().includes(topicSearchInput.toLowerCase()),
          );
        }
        setTopicList(filterData);
      } catch (error) { }
    };
    getPostTopic();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topicSearchInput]);

  useEffect(() => {
    setInProgress(true);
  }, [sortBy, time, searchClick]);

  const handelInfiniteScroll = async () => {
    try {
      if (
        document.getElementById("total-community-post").clientHeight +
        document.getElementById("total-community-post").scrollTop +
        1.9 >=
        document.getElementById("total-community-post").scrollHeight
      ) {
        if (!loadingRef.current && !lastPageRef.current) {
          setFilter((prevState) => ({
            ...prevState,
            page: prevState.page + 1,
          }));
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const handlePostDeleted = () => {
      setAllPost([]);
      lastPageRef.current = false;
      setFilter((prev) => ({ ...prev, page: 1 }));
      getPostCommunity();
    };

    window.addEventListener("POST_DELETED", handlePostDeleted);
    return () => window.removeEventListener("POST_DELETED", handlePostDeleted);
  }, []); // empty deps is fine — getPostCommunity is stable via closure

  useEffect(() => {
    const element = document.getElementById("total-community-post");
    if (element) {
      element.addEventListener("scroll", handelInfiniteScroll);
    }

    return () => {
      if (element) {
        element.removeEventListener("scroll", handelInfiniteScroll);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter.page, community]);

  const getPostCommunity = async () => {
    try {
      setInProgress(true);
      loadingRef.current = true;
      const res = await axios.get(
        `/api/v1/community/post/getByUserId/teacher/${teacher_id}?_page=${page}&_limit=${limit}&sortBy=${sortBy}` +
        `${name
          ? `&name=${name}`
          : tag
            ? `&tags=${encodeURIComponent(tag)}`
            : date
              ? `&date=${date}`
              : ``
        }` +
        `${time && time !== null ? `&time=${time}` : ``}`,
      );

      loadingRef.current = false;
      const totalFetchedPosts = allPost.length + res.data.data.length;
      const loadedQuery = Math.min(
        totalFetchedPosts,
        res.data.total_post_count,
      );
      if (
        res.data.data.length == 0 ||
        loadedQuery === res.data.total_post_count
      ) {
        lastPageRef.current = true;
      }
      setInProgress(false);
      if (page === 1) {
        setAllPost(res.data.data);
      } else {
        setAllPost((prev) => [...prev, ...res.data.data]);
      }
      // if (res.data.data.length > 0) {
      //   toast.info(
      //     `Loading Post (${loadedQuery + "/" + res.data.total_post_count})`,
      //     {
      //       position: "bottom-center",
      //     }
      //   );
      // }
    } catch (error) {
      console.log(error);
      setInProgress(false);
    }
  };

  console.log(isEdited, "isEdited");

  useEffect(() => {
    getPostCommunity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    limit,
    page,
    sortBy,
    time,
    searchClick,
    isPostCreated,
    tag,
    name,
    date,
    isEdited,
  ]);

  const handelTopicSet = (topic) => {
    setTopicPopupOpen(false);
    lastPageRef.current = false;
    setAllPost([]);
    setFilter({
      ...filter,
      page: 1,
      tag: topic,
      searchClick: !searchClick,
    });
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setTopicPopupOpen(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsPostCreated(false);
    }, 4000);

    return () => clearTimeout(timer);
  }, [isPostCreated]);

  return community && community.length > 0 ? (
    <>
      {/* <div className="d-flex flex-column gap-1">
        <span className="head_manual">Community</span>
        <span className="fw-small  text-muted" style={{ fontSize: "10px" }}>
          Dashboard / Community
        </span>
      </div> */}

      <div
        className="w-100 d-flex  gap-4"
        style={{ height: "calc(100vh - 120px)", overflow: "hidden" }}
      >
        <div
          className="p-4 d-flex flex-column gap-1"
          style={{
            width: "70%",
            height: "100%",
            backgroundColor: "white",
            overflow: "hidden",
          }}
        >
          {/* tags */}
          <div className=" gap-2 p-0 d-flex align-items-center topic_container">
            <span className="open_comu_topic ">Trending Tags</span>
            {topicList?.length > 0 &&
              topicList.slice(0, 3).map((item, index) => (
                <button
                  onClick={() => handelTopicSet(item?.topic)}
                  className="topic_name py-1 px-3"
                  key={index}
                >
                  # {item.topic}
                </button>
              ))}

            {!topicPopupOpen && topicList?.length > 0 && (
              <button
                className="topic_name py-1 px-3"
                onClick={(e) => setTopicPopupOpen(true)}
              >
                <span className="topic_more_button">show more</span>
              </button>
            )}
            {topicPopupOpen && (
              <div ref={popupRef} className="topic_popup p-3">
                <div className="topic_list_header d-flex align-items-center justify-content-between mb-3">
                  <span className="topic_label">All Topics</span>
                  <img
                    onClick={(e) => {
                      setTopicPopupOpen(false);
                      setFilter({
                        ...filter,
                        topicSearchInput: "",
                      });
                    }}
                    style={{ cursor: "pointer" }}
                    src="/images/cancel_icon.svg"
                    alt="cancle_icon"
                  />
                </div>
                <div className="topic_search_container mb-3 px-2 py-3 d-flex align-items-center">
                  <img className="mr-1" src="/images/search icon.svg" alt="" />
                  <input
                    type="text"
                    placeholder="Search topics"
                    className="topic_search_box"
                    onChange={(e) =>
                      setFilter({
                        ...filter,
                        topicSearchInput: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="topic_list">
                  {topicList &&
                    topicList.length > 0 &&
                    topicList.map((item, index) => (
                      <div
                        key={index}
                        onClick={() => handelTopicSet(item?.topic)}
                        className="d-flex mb-1 align-items-center justify-content-between"
                      >
                        <span className="topic_list_name">{item?.topic}</span>
                        <span className="topic_post_count">
                          {item?.post_count} Posts
                        </span>
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>
          {/* search by type */}
          <div className="w-100 gap-3 d-flex justify-content-between">
            <div className="d-flex  align-items-center w-100 gap-4">
              <div className="mt-2 search_container d-flex align-items-center post_filter ">
                <div className="dropdown">
                  <Form.Select
                    className="search_dropdown"
                    id="SearchFilter"
                    size="sm"
                    value={option}
                    onChange={(e) => {
                      setOption(e.target.value);
                      setFilter({
                        ...filter,
                        name: "",
                        tag: "",
                        page: 1,
                        date: null,
                      });
                    }}
                  >
                    <option value="">Search by Type</option>
                    <option value="Tag">Tag</option>
                    <option value="Name">Creator</option>
                    <option value="Date">Date</option>
                  </Form.Select>
                </div>

                <div className="search_input_cont">
                  {option === "Date" ? (
                    // <input
                    //   type="date"
                    //   name="date"
                    //   value={date}
                    //   className="search_calendar_Box"
                    //   onChange={(e) => {
                    //     setFilter({
                    //       ...filter,
                    //       name: null,
                    //       tag: null,
                    //       page: 1,
                    //       date: e.target.value,
                    //     });
                    //   }}
                    // />
                    <DatePicker
                      selected={date}
                      placeholderText="mm/dd/yyyy"
                      onChange={(date) => {
                        setFilter({
                          ...filter,
                          name: null,
                          tag: null,
                          page: 1,
                          date: date,
                        });
                      }}
                      className="search_calendar_Box"
                    // onKeyDown={(e) => handleKeyDown(e)}
                    />
                  ) : option === "Name" ? (
                    <input
                      type="text"
                      className="search_boxs"
                      placeholder="enter name"
                      maxLength={50}
                      value={name}
                      onChange={(e) => {
                        setFilter({
                          ...filter,
                          date: null,
                          tag: null,
                          page: 1,
                          name: e.target.value,
                        });
                      }}
                    />
                  ) : (
                    option === "Tag" && (
                      <input
                        type="text"
                        className="search_boxs"
                        placeholder="enter tag"
                        maxLength={20}
                        value={tag}
                        onChange={(e) => {
                          lastPageRef.current = false;
                          setFilter({
                            ...filter,
                            date: null,
                            name: null,
                            page: 1,
                            tag: e.target.value,
                          });
                        }}
                      />
                    )
                  )}
                </div>
                <img
                  src="/images/search icon black.svg"
                  style={{ cursor: "pointer" }}
                  alt=""
                  onClick={(e) => {
                    setAllPost([]);
                    setFilter({
                      ...filter,
                      searchClick: !searchClick,
                    });
                  }}
                />
                <div className="post_filter_icon d-flex align-items-center justify-content-center mx-1">
                  <img
                    src="/images/FilterIcon.svg"
                    alt=""
                    onClick={(e) => setClick1(true)}
                  />
                </div>
                {click1 && (
                  <div className="post_filter1">
                    <FilterBox
                      setChecked={setChecked}
                      checked={checked}
                      setClick1={setClick1}
                      setFilter={setFilter}
                      filter={filter}
                      setAllPost={setAllPost}
                      setSelectedData={setSelectedData}
                      selectedData={selectedData}
                    />
                  </div>
                )}
              </div>
              <div className="">
                <div
                  className="clearSerachTxt"
                  onClick={() => {
                    setFilter({
                      date: null,
                      tag: "",
                      name: "",
                      sortBy: -1,
                      time: null,
                      limit: 3,
                      page: 1,
                      searchClick: false,
                      topicSearchInput: "",
                    });
                    setOption("");
                  }}
                >
                  Clear Search
                </div>
              </div>
            </div>
          </div>
          {/* pOSts */}
          <div className="mt-2 d-flex w-100 ">
            <div
              id="total-community-post"
              className=" post_box  orange-scrollBar w-100 "
            // style={{ width: "1oo%" }}
            >
              {allPost?.length > 0 ? (
                <div className="w-100">
                  {allPost.map((data, idx) => (
                    <PostImage
                      key={idx}
                      post={data}
                      TotalCommuPost={"TotalCommuPost"}
                      community={community}
                      isEdited={isEdited}
                      setIsEdited={setIsEdited}
                      refetch={getPostCommunity}
                    />
                  ))}
                </div>
              ) : (
                !inProgress && (
                  <span className="text-center no_post_yet">
                    No posts yet. Be the first one to add a post to community
                  </span>
                )
              )}
              {inProgress && (
                <div className="w-100 d-flex justify-content-center align-items-center">
                  <img
                    className="ongoing_loader m-0"
                    src="/gif/LoaderDot.gif"
                    alt="loader"
                  />
                </div>
              )}
            </div>
            {/* <div className="clrBtn1 clearSerachTxt">
          <div
            className="clearSerachTxt"
            onClick={() => {
              setFilter({
                date: null,
                tag: "",
                name: "",
                sortBy: -1,
                time: null,
                limit: 3,
                page: 1,
                searchClick: false,
                topicSearchInput: "",
              });
            }}
          >
            Clear Search
          </div>
        </div> */}
          </div>
        </div>
        <div
          className="px-2 py-2  d-flex flex-column gap-4 "
          style={{ width: "30%", height: "100%", backgroundColor: "white" }}
        >
          <div
            className="d-flex flex-column align-items-center justify-content-center w-100 gap-4 py-3 rounded-3"
            style={{ backgroundColor: "#f8f9fb" }}
          >
            <button
              id="open_post_btn"
              class="btn btn-primary post_to_community_button "
              type="button"
              onClick={(e) => setClickPost(true)}
            >
              Post to Community
            </button>
            <Alert
              severity="info"
              onClick={() => setOpenImg(true)}
              sx={{
                cursor: "pointer",
                fontSize: "0.8rem",
                width: "fit-content",
              }}
            >
              Click to Know Details
            </Alert>
            {isPostCreated && (
              <div className=" p-2 post_successfull">
                <img src="/images/Success.png" alt="" />
                <span className="post_successfull_message">
                  Your post has been posted successfully
                </span>
              </div>
            )}
          </div>
          {/* Community UI */}
          <div
            className=" mt-2 channels_box rounded-3 py-3 px-2 w-100"
            style={{ backgroundColor: "#f8f9fb", overflow: "hidden" }}
          >
            <div className="mb-2 d-flex align-items-center justify-content-between channel_createBtn border-bottom border-3 pb-2">
              <span className="channel_header">Channels</span>

              <span
                className="create_channel_btn"
                onClick={(e) => {
                  setClickCreate(true);
                  localStorage.setItem("STUDENT_OPTIONS_STORAGE_KEY", []);
                  localStorage.setItem("TEACHER_OPTIONS_STORAGE_KEY", []);
                }}
              >
                + Create Channel
              </span>
            </div>
            <div className="channel_boxs orange-scrollBar px-2 py-1">
              {/* <ChannelBoxProps /> */}
              {/* <ChannelBox /> */}
              {community && community.length > 0 ? (
                community.map((data, index) => (
                  <ChannelBox
                    key={index}
                    setActive={setActive}
                    postCreatedCount={postCreatedCount}
                    selectedCommunity={selectedCommunity}
                    setViewFirstInProgress={setViewFirstInProgress}
                    viewFirstInProgress={viewFirstInProgress}
                    postRequestCount={postRequestCount}
                    communityData={data}
                  />
                ))
              ) : (
                <div className="no-channel">No Channel Available Yet.</div>
              )}
            </div>
          </div>
        </div>
      </div>
      {clickCreate && <CreateChannelFirst change={setClickCreate} />}
      {clickPost && (
        <CreatePostFirst
          setAllPost={setAllPost}
          setChoosedCommunity={setSelectedCommunity}
          setPostCreatedCount={setPostCreatedCount}
          setIsPostCreated={setIsPostCreated}
          setClickPost={setClickPost}
          clickPost={clickPost}
          post={allPost}
        />
      )}
      {openImg && (
        <ImagePopupBox setOpenImg={setOpenImg} imgSrc={CommuityImage} />
      )}
    </>
  ) : !community.length === 0 ? (
    <div>No Community data found!</div>
  ) : (
    <>
      <div
        style={{ fontFamily: "Roboto", color: "blue" }}
        className="text-center h-100 w-100 d-flex justify-content-center align-items-center"
      >
        Please wait, we are loading Community data ...
      </div>
      <img className="Loader" src="/gif/LoaderDot.gif" alt="" />
    </>
  );
};

export default TotalCommuPost;
